import { render, staticRenderFns } from "./collect-product.vue?vue&type=template&id=002d2765&scoped=true&"
import script from "./collect-product.vue?vue&type=script&lang=js&"
export * from "./collect-product.vue?vue&type=script&lang=js&"
import style0 from "./collect-product.vue?vue&type=style&index=0&id=002d2765&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002d2765",
  null
  
)

export default component.exports